import React from "react";
import { Box, Button, Typography, IconButton, Badge } from "@mui/material";
import UnreadCountBadge from "./UnreadCountBadge";

export default function HeaderUnreadButtons({
  isDesktop,
  onOpen,
  projectUnreadCount = 0,
  jobUnreadCount = 0,
  totalUnreadCount = 0,
}) {
  return isDesktop ? (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button
        sx={{
          color: "#545454",
          border: "1px solid #545454",
          borderRadius: 0,
          gap: "5px",
          px: "12px",
          "&:hover": {
            backgroundColor: "#E5E7EB",
          },
        }}
        onClick={() => onOpen("projects")}
      >
        <Typography sx={{ fontSize: "12px" }}>未読プロジェクト ｜</Typography>
        <UnreadCountBadge count={projectUnreadCount}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            width="24"
            height="24"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M155.8 96C123.9 96 96.9 119.4 92.4 150.9L64.6 345.2C64.2 348.2 64 351.2 64 354.3L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 354.3C576 351.3 575.8 348.2 575.4 345.2L547.6 150.9C543.1 119.4 516.1 96 484.2 96L155.8 96zM155.8 160L484.3 160L511.7 352L451.8 352C439.7 352 428.6 358.8 423.2 369.7L408.9 398.3C403.5 409.1 392.4 416 380.3 416L259.9 416C247.8 416 236.7 409.2 231.3 398.3L217 369.7C211.6 358.9 200.5 352 188.4 352L128.3 352L155.8 160z" />
          </svg>
        </UnreadCountBadge>
      </Button>

      <Button
        sx={{
          color: "#545454",
          border: "1px solid #545454",
          borderRadius: 0,
          gap: "5px",
          px: "12px",
          "&:hover": {
            backgroundColor: "#E5E7EB",
          },
        }}
        onClick={() => onOpen("jobs")}
      >
        <Typography sx={{ fontSize: "12px" }}>未読求人 ｜</Typography>
        <UnreadCountBadge count={jobUnreadCount}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 640"
            width="24"
            height="24"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M155.8 96C123.9 96 96.9 119.4 92.4 150.9L64.6 345.2C64.2 348.2 64 351.2 64 354.3L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 354.3C576 351.3 575.8 348.2 575.4 345.2L547.6 150.9C543.1 119.4 516.1 96 484.2 96L155.8 96zM155.8 160L484.3 160L511.7 352L451.8 352C439.7 352 428.6 358.8 423.2 369.7L408.9 398.3C403.5 409.1 392.4 416 380.3 416L259.9 416C247.8 416 236.7 409.2 231.3 398.3L217 369.7C211.6 358.9 200.5 352 188.4 352L128.3 352L155.8 160z" />
          </svg>
        </UnreadCountBadge>
      </Button>
    </Box>
  ) : (
    <IconButton sx={{ color: "#545454", p: 0 }} onClick={() => onOpen()}>
      {(() => {
        // 未読が0件ならバッジを非表示にする
        const invisible = totalUnreadCount === 0;

        return (
          <Badge
            variant="dot"
            color="error"
            overlap="circular"
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            invisible={invisible}
            sx={{
              "& .MuiBadge-badge": {
                height: "12px",
                minWidth: "12px",
                borderRadius: "50%",
                transform: "translate(40%, -40%)",
              },
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 640"
              width="25"
              height="25"
              fill="currentColor"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M155.8 96C123.9 96 96.9 119.4 92.4 150.9L64.6 345.2C64.2 348.2 64 351.2 64 354.3L64 480C64 515.3 92.7 544 128 544L512 544C547.3 544 576 515.3 576 480L576 354.3C576 351.3 575.8 348.2 575.4 345.2L547.6 150.9C543.1 119.4 516.1 96 484.2 96L155.8 96zM155.8 160L484.3 160L511.7 352L451.8 352C439.7 352 428.6 358.8 423.2 369.7L408.9 398.3C403.5 409.1 392.4 416 380.3 416L259.9 416C247.8 416 236.7 409.2 231.3 398.3L217 369.7C211.6 358.9 200.5 352 188.4 352L128.3 352L155.8 160z" />
            </svg>
          </Badge>
        );
      })()}
    </IconButton>
  );
}
